import axios from "axios";
import errorHandler from "./errorHandler";
import successHandler from "./successHandler";
import storePersist from "./../redux/storePersist";
import getRequestURl from "./requester";
import { getAccountTypeChannalName } from "../common/services/common.service";

export let tenantDetails = {
  SalesChannelName: "",
  StoreId: "",
  SalesChannelId: "",
  CountryCode: "",
  CurrencyCode: "",
  LanguageCode: "",
};
const request = {
  create: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
    publish: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const guestTokenMetadata = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(guestTokenMetadata?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessTokenMetadata")?.current?.JwtToken
                ? storePersist?.get("accessTokenMetadata")?.current?.JwtToken
                : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  read: async ({ url, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData?.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData?.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData?.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.get(url, {
        method: "GET",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  print: async ({ url, jsonData, entity }) => {
    // console.log('read options', options)
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  update: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName = accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.put(url, jsonData, {
        method: "PUT",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  delete: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  query: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData?.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData?.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData?.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      // let query = "?";
      // for (var key in options) {
      //   query += key + "=" + options[key] + "&";
      // }
      // query = query.slice(0, -1);

      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  list: async ({ url, jsonData, entity, options = { limit: 5 } }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;
      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      // let query = "?";
      // for (var key in options) {
      //   query += key + "=" + options[key] + "&";
      // }
      // query = query.slice(0, -1);

      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
    generateDataExport: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const guestTokenMetadata = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(guestTokenMetadata?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessTokenMetadata")?.current?.JwtToken
                ? storePersist?.get("accessTokenMetadata")?.current?.JwtToken
                : guestToken
            }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  summary: async ({ url, jsonData, entity, options = { limit: 5 } }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      // let query = "?";
      // for (var key in options) {
      //   query += key + "=" + options[key] + "&";
      // }
      // query = query.slice(0, -1);

      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  uploadCreate: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "multipart/form-data",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  count: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    const accessToken = localStorage.getItem("access-token");
    if (entity === "channels") {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList.find(
        (element) => element.SalesChannelName === "CSP"
      );
      tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }
    if (entity === "queryByStores") {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode = metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode = metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode = metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      const tokenData = getAccountTypeChannalName();
      const accountTypeBasedChannel = JSON.parse(tokenData?.channelName);
      tenantDetails.SalesChannelName =
        accountTypeBasedChannel?.SalesChannelName;
      tenantDetails.StoreId = accountTypeBasedChannel?.StoreId;
      tenantDetails.SalesChannelId = accountTypeBasedChannel?.SalesChannelId;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
          Channel: tenantDetails?.SalesChannelName || null,
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "multipart/form-data",
          Authorization:
            "Bearer " +
            `${accessToken
              ? accessToken
              : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },

};

export default request;
